<mat-drawer-container class="component-container" hasBackdrop="true">
  <mat-drawer class="drawer-menu" #menuPanel mode="over">
    <app-sidebar-menu #sidebarMenuComponent [menuData]="loggedUser.opciones"
      (click)="menuPanel.toggle()"></app-sidebar-menu>
  </mat-drawer>

  <mat-drawer-content>
    <div class="container-header">
      <mat-toolbar class="toolbar-header-static">

        <!-- 1. Contenedor Menú/Home -->
        <div class="menu-container">
          <mat-icon class="icon-header" matTooltip="Menú" (click)="menuPanel.toggle()" svgIcon="menu_icon"></mat-icon>
          <mat-icon class="icon-header" matTooltip="Home" (click)="goHome()" svgIcon="home_icon"></mat-icon>
        </div>

        <!-- 2. Título Sección -->
        <div class="section-name-container">
          <span class="section-title">
            {{sectionName.toUpperCase()}}
          </span>
          <span class="app-title">
            OFICINA VIRTUAL DE
            <span class="app-title-logo">
              asesores
            </span>
          </span>
        </div>

        <!-- 3. Datos del Usuario -->
        <div class="user-data-container">
          <span style="font-family: MainFontBolder;">¡HOLA {{loggedUser.nombre.toUpperCase()}}
            {{loggedUser.primerApellido.toUpperCase()}}!</span>
          <span class="text-data hide"> {{loggedUser.document}} <span style="font-weight: bold;">|</span>
            {{loggedUser.email.toLowerCase()}}</span>
          <span class="text-data">{{loggedUser.roles[0].nombreRol.toUpperCase()}}</span>
        </div>

        <!-- 4. Contenedor Notificaciones -->
        <div class="notifications-container">
          <div class="notification-wrapper">
            <mat-icon class="icon-header bell-icon link-style" matTooltip="Notificaciones"
              (click)="toggleTooltip(); $event.stopPropagation()" svgIcon="notifications_icon">
            </mat-icon>

            <span class="notification-badge" *ngIf="showBadge">{{ notificationCount }}</span>
          </div>

          <!-- CONTENEDOR PADRE DEL RECUADRO DE NOTIFICACIONES -->
          <div *ngIf="showTooltip" class="tooltip-wrapper">

            <div *ngIf="tipoAsesor === 'Asesor Externo' && showTooltipNotificacion1"
              class="tooltip-card extra-notification" (click)="onExtraNotificationClick()">
              <span class="tooltip-date">{{ fechaNotificacionTexto }}</span>
              <p>
                <strong>¡Disponible liquidación comisiones!</strong> <br />
                Apreciado(a) asesor(a), ya se encuentra disponible el
                comprobante y detallado correspondiente a la
                producción de la <strong>{{ quincenaActual }}</strong> quincena de
                <strong>{{ mesActual }}</strong>. Haz clic para conocer las fechas
                y recomendaciones de radicación.
              </p>
            </div>

            <div *ngIf="notificacionMomentosWow" class="tooltip-card" (click)="onMomentoWOWClick()">
              <h1 class="tooltip-title">
                Momentos WOW
              </h1>
              <p>
                ¡Tienes un momento para celebrar! Haz click aquí
                para visualizar.
              </p>
            </div>

            <div *ngIf="showTooltip" class="tooltip-card" (click)="onNotificationClick()">
              <span class="tooltip-date">{{fechaNotificacionTooltip}}</span>
              <p>
                ¡Tienes <strong>{{ totalUsuariosCumplen }} usuarios</strong> que ya cumplieron
                2 meses desde que inició su servicio!<br />
                Haz clic aquí para ver quiénes son y contactarlos.
              </p>
            </div>
			
			
			
			
			
			
			<div class="tooltip-card notif-cotizaciones" (click)="goToNotificacionesCotizacion()">
                  <span class="tooltip-date">Alertas de cotizaciones</span>
                  <p>
                    <strong *ngIf="notificacionesSeguimientoNoLeidas > 0">
                      {{ notificacionesSeguimientoNoLeidas }} alerta<span *ngIf="notificacionesSeguimientoNoLeidas > 1">s</span> sin leer
                    </strong>
                    <span *ngIf="notificacionesSeguimientoNoLeidas === 0">Sin alertas nuevas</span>
                    <br/>Haz clic para ver todas.
                  </p>
            </div>
          </div>
        </div>

        <!-- 5. Botón Cerrar Sesión -->
        <div class="logout-container">
          <mat-icon class="icon-header link-style" matTooltip="Cerrar sesión" (click)="closeSession()"
            svgIcon="logout_icon"></mat-icon>
        </div>

      </mat-toolbar>
    </div>

    <!-- Contenido Principal -->
    <div class="container-main">
      <router-outlet></router-outlet>
    </div>

  </mat-drawer-content>
</mat-drawer-container>

<!-- Loader Momentos WOW -->
<div class="momentos-wow-loader-backdrop" *ngIf="cargandoMomentosWow">
  <div class="momentos-wow-loader-card">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Cargando Momentos WOW...</p>
  </div>
</div>